import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { GenericService } from "app/_services/generic.service";

@Injectable({
    providedIn: 'root',
  })

  export class WorkActivityService extends GenericService<any> {
    workActivityClientTaskUrl: string = '/WorkActivity/ClientTask';
    constructor(private http: HttpClient) {
        super(http, '/workActivity/',)
      }

    getworkActivityClientTasks() {
      return this._http.get(this.rootUrl + this.workActivityClientTaskUrl, this.prepareHeader());
    }
  }